import React from 'react';

const Main = (props) => (
  <article className="d-flex flex-column align-items-center">
    {props.children}
  </article>
);

export default Main;
